import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ExamRegistrationCards.css';

const EXAM_CARDS = [
    { name: 'DHA', fullName: 'Dubai Health Authority', price: '300', popular: true },
    { name: 'SCFHS', fullName: 'Saudi Commission for Health Specialties', price: '300', popular: true }, // SCFHS is often SCHS in some contexts, stick to user's "SCHS"
    { name: 'DHP', fullName: 'Department of Healthcare Professions - Qatar', price: '300' },
    { name: 'MOHKW', fullName: 'Ministry of Health - Kuwait', price: '300' },
    { name: 'NHRA', fullName: 'National Health Regulatory Authority - Bahrain', price: '300' },
];

const ExamRegistrationCards = () => {
    const navigate = useNavigate();

    const handleBookNow = (examName) => {
        navigate(`/book-exam/${examName}`);
    };

    return (
        <section className="exam-registration-section" id="register-exam">
            <Container>
                <div className="section-header text-center mb-5">
                    <h2 className="section-title">Register Your Exam</h2>
                    <p className="section-subtitle">Select your desired exam authority to proceed with booking</p>
                </div>

                <Row className="justify-content-center g-4">
                    {EXAM_CARDS.map((exam) => (
                        <Col key={exam.name} xs={12} sm={6} md={4} lg={4} className="d-flex justify-content-center mb-4 exam-card-col">
                            <Card
                                className={`home-exam-card shadow-sm border-0 ${exam.popular ? 'popular-card' : ''}`}
                                style={{ height: '440px', minHeight: '440px' }}
                            >
                                {exam.popular && <div className="popular-badge">Popular</div>}
                                <Card.Body className="d-flex flex-column align-items-center text-center p-4" style={{ height: '100%' }}>
                                    {/* TalentTrack Logo Watermark */}
                                    <div className="exam-card-logo">
                                        <img
                                            src="/assets/logos/talent-track-logo.jpg"
                                            alt="Talent Track"
                                            className="card-logo-img"
                                        />
                                    </div>

                                    <div className="exam-icon mb-3">
                                        <span className="exam-initials">{exam.name}</span>
                                    </div>
                                    <Card.Title className="exam-title mb-2">{exam.name}</Card.Title>
                                    <Card.Text className="exam-fullname mb-4">
                                        {exam.fullName}
                                    </Card.Text>

                                    <div className="card-footer-content mt-auto w-100">
                                        {/* Professional Price Display */}
                                        <div className="exam-price-wrapper">
                                            <div className="price-label-text">Registration Fee</div>
                                            <div className="exam-price">
                                                <span className="currency-sign">$</span>
                                                <span className="amount">{exam.price}</span>
                                                <span className="currency-text">USD</span>
                                            </div>
                                        </div>

                                        <div className="price-divider"></div>

                                        <Button
                                            variant="primary"
                                            className="book-now-btn w-100"
                                            onClick={() => handleBookNow(exam.name)}
                                        >
                                            Book Now
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default ExamRegistrationCards;
